/**
 * Replaces one attachment category while retaining the files in every other category.
 * The engagement-letter uploader uses this to merge its upload result back into the
 * draft without dropping ordinary supporting attachments.
 */
export function mergeAttachmentCategory(allAttachments, category, nextCategoryFiles) {
  const current = Array.isArray(allAttachments) ? allAttachments : [];
  const replacement = Array.isArray(nextCategoryFiles) ? nextCategoryFiles : [];
  const otherCategories = current.filter((file) => (file.category || 'other') !== category);
  return [...otherCategories, ...replacement];
}

/**
 * FileList is live: clearing a file input also clears its `.files` collection. Snapshot
 * the selected files before resetting the input so the async upload still receives them.
 */
export function snapshotPickedFiles(fileList) {
  return Array.from(fileList || []);
}
